import bannerImg from './banners/woman-helping-man-gym.jpg';

const anamneseCorridaAvancado = (t) => ({
    id: 'anamnese-corrida-avancado',
    title: t('templates.items.anamneseCorridaAvancado.title'),
    description: t('templates.items.anamneseCorridaAvancado.description'),
    indicatedFor: t('templates.audiences.runningCoaches'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.anamneseCorridaAvancado.summary.personalRecord'),
        t('templates.items.anamneseCorridaAvancado.summary.weeklyVolume'),
        t('templates.items.anamneseCorridaAvancado.summary.raceGoal'),
        t('templates.items.anamneseCorridaAvancado.summary.injuryHistory'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.anamneseCorridaAvancado.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.anamneseCorridaAvancado.form.performance.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseCorridaAvancado.form.performance.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.anamneseCorridaAvancado.form.performance.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.anamneseCorridaAvancado.form.performance.personalRecord.label'),
                        description: t('templates.items.anamneseCorridaAvancado.form.performance.personalRecord.description'),
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'number',
                        label: t('templates.items.anamneseCorridaAvancado.form.performance.weeklyVolume.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.options.tenKm') },
                                { id: 'opt-2', label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.options.halfMarathon') },
                                { id: 'opt-3', label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.options.marathon') },
                                { id: 'opt-4', label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.options.ultraTrail') },
                                { id: 'opt-5', label: t('templates.items.anamneseCorridaAvancado.form.performance.nextRace.options.improvePr') },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.anamneseCorridaAvancado.form.history.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseCorridaAvancado.form.history.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: t('templates.items.anamneseCorridaAvancado.form.history.injury.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.anamneseCorridaAvancado.form.history.currentTraining.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.anamneseCorridaAvancado.form.history.bottlenecks.label'),
                        description: t('templates.items.anamneseCorridaAvancado.form.history.bottlenecks.description'),
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default anamneseCorridaAvancado;
